import { TelemetryFieldKey } from 'api/v5/v5';
import { DataSource } from 'types/common/queryBuilder';

import { FontSize, OptionsQuery } from './types';

export const URL_OPTIONS = 'options';

export const defaultOptionsQuery: OptionsQuery = {
	selectColumns: [],
	maxLines: 1,
	format: 'raw',
	fontSize: FontSize.SMALL,
};

export const EXCLUDED_COLUMNS: Record<DataSource, string[]> = {
	[DataSource.TRACES]: ['body', 'isRoot', 'isEntryPoint'],
	[DataSource.METRICS]: ['body'],
	[DataSource.LOGS]: [],
};

// 로그 목록이 렌더에 반드시 필요로 하는 컬럼. 사용자가 선택에서 지워도 리스트
// 렌더러가 되살린다. **여기에 선택 가능한 컬럼을 넣으면 안 된다** — 넣는 순간
// 사용자가 그 컬럼을 지울 수 없게 된다.
export const requiredLogColumns: TelemetryFieldKey[] = [
	{
		name: 'timestamp',
		signal: 'logs',
		fieldContext: 'log',
		fieldDataType: '',
		isIndexed: false,
	},
	{
		name: 'body',
		signal: 'logs',
		fieldContext: 'log',
		fieldDataType: '',
		isIndexed: false,
	},
];

export const defaultLogsSelectedColumns: TelemetryFieldKey[] = [
	...requiredLogColumns,
	// 다중 호스트 환경에서 화면만 보고 출처를 알 수 없어 기본 노출한다.
	// 둘 다 OTel 리소스 속성이므로 fieldContext는 'resource'여야 값이 채워진다.
	// 기본값일 뿐 필수는 아니므로 사용자가 지우면 지워진 채로 남는다.
	{
		name: 'service.name',
		signal: 'logs',
		fieldContext: 'resource',
		fieldDataType: '',
		isIndexed: false,
	},
	{
		name: 'host.name',
		signal: 'logs',
		fieldContext: 'resource',
		fieldDataType: '',
		isIndexed: false,
	},
];

// defaultOptionsQuery는 트레이스 등과 공유되므로 직접 손대지 않는다.
// 로그는 본문이 길어 한 줄로는 판독이 어려워 기본 2줄로 둔다.
export const defaultLogsOptionsQuery: OptionsQuery = {
	...defaultOptionsQuery,
	maxLines: 2,
	selectColumns: defaultLogsSelectedColumns,
};

export const defaultTraceSelectedColumns: TelemetryFieldKey[] = [
	{
		name: 'service.name',
		signal: 'traces',
		fieldContext: 'resource',
		fieldDataType: 'string',
	},
	{
		name: 'name',
		signal: 'traces',
		fieldContext: 'span',
		fieldDataType: 'string',
	},
	{
		name: 'duration_nano',
		signal: 'traces',
		fieldContext: 'span',
		fieldDataType: '',
	},
	{
		name: 'http_method',
		signal: 'traces',
		fieldContext: 'span',
		fieldDataType: '',
	},
	{
		name: 'response_status_code',
		signal: 'traces',
		fieldContext: 'span',
		fieldDataType: '',
	},
];
